import React, { Component } from 'react';
import Countdown from 'react-countdown-now';
import Blockies from 'react-blockies';
import { Icon, Tooltip } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { inject, observer } from 'mobx-react';

class CustomBetsCardTaken extends Component {
    constructor(props) {
        super(props);

        this.state = {
            toolTipMessage: 'Click to Copy',
        };
        
    }

    render() {
        let timeNow = new Date().getTime() / 1000;
        let cardClassName = ""
        let openClosedIcon = ""

        if (this.props.endTime > timeNow) {
            cardClassName = "custom-bets-page-cards-open";
            openClosedIcon = <div className="custom-bets-page-cards-status-open-expired-icon">
                <div className="open-icon"></div>
                <span>Open</span>
            </div>
        } else {
            cardClassName = "custom-bets-page-cards-closed";
            openClosedIcon = <div className="custom-bets-page-cards-status-open-expired-icon">
                <div className="closed-icon"></div>
                <span style={{color: '#f73527'}}>Closed</span>
            </div>
        }
        return (
            <div className="custom-bets-page-cards">
                <div className={cardClassName}>
                    <div className="custom-bets-page-rows-teams">
                         <div className="custom-bets-page-rows-teams-teamone">
                            {this.props.taker != "" ? <span><img /></span> : <span><Icon type="hourglass" /></span>}
                            <div>{this.props.taker != "" ? this.props.taker : "WAITING FOR TAKER"}</div>
                        </div>
                        <div className="custom-bets-page-rows-teams-vs">
                            <div style={{ marginTop: '-10px' }}>
                                VS
                        </div>
                        </div>
                        <div className="custom-bets-page-rows-teams-teamtwo">
                            <span><Blockies seed={this.props.makerEthAdress} /></span>
                            {/* //src="http://www.countryflags.io/CA/flat/64.png" width="30px" /></span> */}
                            <div>YOU</div>
                        </div>
                    </div>
                    <div className="custom-bets-page-cards-event-info">
                    <CopyToClipboard text={this.props.wagerId} onCopy={() => this.setState({ toolTipMessage: 'Copied!' })}>
                            <Tooltip placement="bottom" title={this.state.toolTipMessage}>
                            <div>BET ID : {this.props.wagerId}</div>
                            </Tooltip>
                        </CopyToClipboard>
                    </div>
                    <div className="custom-bets-page-cards-event-info">
                        {this.props.status}
                    </div>
                    <div className="custom-bets-page-cards-bet-options-pick-title">
                        <span>OUTCOMES</span>
                    </div>
                    <div className="custom-bets-page-cards-bet-options">
                        <button className="custom-bets-page-cards-options-teamone">
                            <span className="custom-bets-page-cards-bet-options-title">YOU</span>
                            <div className="custom-bets-page-cards-bets-amount">{this.props.outcomeOne}</div>
                        </button>
                        <button className="custom-bets-page-cards-options-teamtwo">
                            <span className="custom-bets-page-cards-bet-options-title">OPPONNENT</span>
                            <div className="custom-bets-page-cards-bets-amount">{this.props.outcomeTwo}</div>
                        </button>
                    </div>
                    <div className="custom-bets-page-cards-status">
                        <div className="custom-bets-page-cards-status-open-expired">
                            {openClosedIcon}
                            <div className="custom-bets-page-cards-status-time-remaining">
                                <Countdown zeroPadLength={2} date={new Date(this.props.endTime).getTime() * 1000}>
                                    <span>ENDED, NO TIME</span>
                                </Countdown>
                                <span style={{ marginLeft: '5px' }}>REMAINING</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CustomBetsCardTaken;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/CustomBetsCardTaken.js